
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetRelatedProductCollectionApiV2Parameter, getRelatedProductsCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import { BaseModel, ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";

export type WhereToUseFilter = {
    assemblyPartNo?: string,
    assemblyClassCode?:string,
    assemblyLineCode?: string,
    assemblyName?:string
}
export type WhereToUsedParams = {
    filter: WhereToUseFilter
} & GetRelatedProductCollectionApiV2Parameter & BaseModel;

interface Props {
    apiParameter: WhereToUsedParams;
    apiResult: ProductCollectionModel;
}
type HandlerType = Handler<WhereToUsedParams, Props>;

const setParams: HandlerType = props => {
    props.dispatch({ type: "BeginLoadWhereUsedProducts" } as any);
    props.apiParameter = {
        ...props.apiParameter,
        productId: props.parameter.productId,
        relationship: props.parameter.relationship,
        page: props.parameter.page || 1,
        pageSize: props.parameter.pageSize,
        additionalQueryStringParameters: props.parameter.filter
    };
}
const getWhereUsedProductsData: HandlerType = async props => {

    try {
        if ("relationship" in props.apiParameter) {
            props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);

            props.dispatch({
                type: "CompleteLoadWhereUsedProducts",
                productId: props.parameter.productId,
                products: props.apiResult.products,
                pagination: props.apiResult.pagination
            } as any);
        }
    } catch (error) {
        props.dispatch({ type: "FailedLoadWhereUsedProducts" } as any);
        console.error("Failed to load related products", error);
    }
};
export const chain = [
    setParams,
    getWhereUsedProductsData,
];

const loadWhereUsedProducts = createHandlerChainRunner(chain, "LoadWhereUsedProducts");
export default loadWhereUsedProducts;
